import { Link, LinkButton, A } from './link';

export { A, LinkButton };
export default Link;
